// src/components/jb-icon/jb-icon.custom.ts
var materialIconNames = [
  "material:add_2",
  "material:alternate_email",
  "material:arrow_drop_down",
  "material:arrow_drop_up",
  "material:backup",
  "material:border_color",
  "material:browse_activity",
  "material:calendar_month",
  "material:call",
  "material:captive_portal",
  "material:chat_bubble",
  "material:check",
  "material:chevron_backward",
  "material:chevron_forward",
  "material:circle",
  "material:clarify",
  "material:close",
  "material:content_copy",
  "material:contract",
  "material:dehaze",
  "material:delete",
  "material:download",
  "material:draft",
  "material:drag_indicator",
  "material:east",
  "material:edit",
  "material:error",
  "material:favorite",
  "material:favorite-fill",
  "material:filter_list",
  "material:fullscreen",
  "material:fullscreen_exit",
  "material:headphones",
  "material:home",
  "material:image",
  "material:info",
  "material:keyboard_arrow_down",
  "material:keyboard_arrow_up",
  "material:language",
  "material:location_on",
  "material:lock",
  "material:mail",
  "material:menu",
  "material:menu_book",
  "material:more_horiz",
  "material:news",
  "material:newsmode",
  "material:north",
  "material:north_east",
  "material:open_in_new",
  "material:pace",
  "material:page_info",
  "material:pause",
  "material:pause-fill",
  "material:person",
  "material:person_check",
  "material:person_remove",
  "material:play_arrow",
  "material:play_arrow-fill",
  "material:quiz",
  "material:redo",
  "material:refresh",
  "material:remove",
  "material:reply",
  "material:save",
  "material:search",
  "material:sentiment_dissatisfied-fill",
  "material:sentiment_dissatisfied",
  "material:sentiment_neutral-fill",
  "material:sentiment_neutral",
  "material:sentiment_satisfied-fill",
  "material:sentiment_satisfied",
  "material:sentiment_stressed-fill",
  "material:sentiment_stressed",
  "material:sentiment_very_satisfied-fill",
  "material:sentiment_very_satisfied",
  "material:settings",
  "material:share",
  "material:shield",
  "material:south",
  "material:south_east",
  "material:star",
  "material:star-fill",
  "material:subtitles",
  "material:subtitles-fill",
  "material:sync_disabled",
  "material:thumb_down-fill",
  "material:thumb_down",
  "material:thumb_up-fill",
  "material:thumb_up",
  "material:timer",
  "material:undo",
  "material:upload",
  "material:videocam",
  "material:view_cozy",
  "material:visibility",
  "material:volume_off",
  "material:volume_up",
  "material:west",
  "material:workspace_premium",
  "material:workspaces"
];
var proprietaryIconNames = [
  "proprietary:youtube",
  "proprietary:bluesky",
  "proprietary:instagram",
  "proprietary:linkedin",
  "proprietary:facebook",
  "proprietary:google",
  "proprietary:businessinsider",
  "proprietary:apple_podcast",
  "proprietary:spotify_podcast",
  "proprietary:google_podcast",
  "proprietary:x"
];
var customIconNames = [
  "custom:eservice",
  "custom:globe",
  "custom:excel-xls",
  "custom:pdf",
  "custom:powerpoint-ppt",
  "custom:word-doc"
];
var animatedIconNames = ["animated:eservice", "animated:globe", "animated:burger", "animated:lock"];
var iconNames = [
  ...materialIconNames,
  ...proprietaryIconNames,
  ...customIconNames,
  ...animatedIconNames
];
var commonSizes = ["small", "regular", "large", "20", "24", "32", "48"];

export {
  materialIconNames,
  proprietaryIconNames,
  customIconNames,
  animatedIconNames,
  iconNames,
  commonSizes
};
